import dynamic from 'next/dynamic';
export default dynamic(() => import(/* webpackChunkName: "blazePbBanner" */'./Banner'));
//# sourceMappingURL=index.js.map